import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { PaypalService } from 'src/app/services/paypal.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-delete-payment-methods-modal',
    templateUrl: './delete-payment-methods-modal.component.html',
    styleUrls: ['./delete-payment-methods-modal.component.scss'],
    standalone: true,
    imports: [LottieComponent, MatFormFieldModule, MatIconModule, MatButtonModule, TitleCasePipe, TranslateModule]
})
export class DeletePaymentMethodsModalComponent implements OnInit {

  public loading = false;
  public showCardError = false;
  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };
  constructor(
    private dialogRef: MatDialogRef<DeletePaymentMethodsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private paypalService: PaypalService
  ) { }

  ngOnInit(): void {
  }

  public closeModal(status: boolean): void {
    this.dialogRef.close(status);
  }

  public async deleteCard(): Promise<void> {
    this.loading = true;
    try {
      await this.paypalService.deleteRememberedCard(this.data.paymentMethod.id);
      this.showCardError = false;
      this.loading = false;
      this.closeModal(true);
    } catch (error: any) {
      this.loading = false;
      if (error?.error?.data?.error === 'Card have a current order.') {
        this.showCardError = true;
      }
    }
  }

  public async deleteAccount(): Promise<void> {
    this.loading = true;
    try {
      await this.paypalService.deleteRememberedAccount();
      this.loading = false;
      this.closeModal(true);
    } catch (error) {
      this.loading = false;
    }
  }

}
